export const CHANGEVIEW = 'CHANGEVIEW'
export const CHANGELANG = 'CHANGELANG'
export const CHANGELOGIN = 'CHANGELOGIN'
export const CHANGETRANLATEARR = 'CHANGETRANLATEARR'
export const CHANGEPAGETITLE = 'CHANGEPAGETITLE'
export const CHANGEBASKET = 'CHANGEBASKET'

